<template>
  <div class="text-select-input clearfix">
    <div class="form-group">
      <label :class="options.fullWidth ? 'col-sm-12' : 'col-sm-4 control-label'">
        {{ options.label }}
        <span v-if="options.required" class="required">*</span>
      </label>
      <div :class="options.fullWidth ? 'col-sm-12' : 'col-sm-8'">
        <select class="form-control" ref="dropdown"
        :name="options.name" @change="validate()">
          <option v-for="val in options.existing"
            :value="val"
            :checked="val === value">{{ val }}</option>
        </select>
        <span :class="validationClass" v-show="validationMessage">
          {{ validationMessage }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import Choices from 'choices.js'
import {
  validationClass,
  validationIcon,
  validationMessage
} from '@/util/helpers'

export default {
  name: 'TextSelectInput',
  props: {
    value: {
      type: String
    },
    options: {
      type: Object,
      default () {
        return {
          value: '',
          label: 'Text',
          name: 'text-select',
          existing: [],
          required: false
        }
      }
    }
  },
  data () {
    return {
      isDirty: false,
      isValid: false,
      currentResults: false,
      choices: false,
      maxLength: false,
      minLength: 1
    }
  },
  computed: {
    invalidMessage () {
      if (this.value && this.maxLength && this.value.length > this.maxLength) {
        return 'Max characters cannot exceed ' + this.maxLength
      } else {
        return this.options.label + ' is required'
      }
    },
    label () {
      return this.options.singleLabel
        ? this.options.singleLabel
        : this.options.label
    },
    validationClass,
    validationIcon,
    validationMessage
  },
  mounted () {
    if (this.options.maxLength) { this.maxLength = this.options.maxLength }
    let $vm = this
    /* eslint-disable no-new */
    this.choices = new Choices(this.$refs.dropdown, {
      placeholderValue: 'Enter a ' + this.options.label,
      noResultsText: 'Press enter to add a new value',
      removeItemButton: true,
      fuseOptions: {
        threshold: 0
      },
      callbackOnInit: function () {
        if (!$vm.value) {
          let arr = this.store.getItemsFilteredByActive()
          if (arr.length > 0) {
            let value = arr.pop().value
            this.removeItemsByValue(value)
          }
        } else {
          this.setValueByChoice($vm.value)
        }
      }
    })
    // add custom adding items behaviour
    this.$refs.dropdown.addEventListener('search', (event) => {
      this.currentResults = !this.choices.choiceList.innerHTML.includes('Press enter to add a new value')
      this.choices.input.addEventListener('keydown', this.addSearchValue)
    })
    // fix bug that causes dropdown to continually close until a key event is detected
    this.$refs.dropdown.addEventListener('showDropdown', (event) => {
      this.choices.clearInput()
      this.$nextTick(function () {
        var e = new window.Event('keydown', {
          'bubbles': true
        })
        e.key = 'a'
        e.keyCode = e.key.charCodeAt(0)
        e.which = e.keyCode
        e.altKey = false
        e.ctrlKey = true
        e.shiftKey = false
        e.metaKey = false
        this.choices.input.dispatchEvent(e)
        this.choices.input.focus()
      })
    })
  },
  methods: {
    async validate (val) {
      await this.$nextTick()
      let data = false
      if (!val) {
        data = this.choices.getValue()
        val = data ? data.value : null
      }
      this.$emit('input', val)
      this.isDirty = true
      if (val) {
        this.isLength = this.isValid = val.length >= this.minLength
        if (this.isLength && this.maxLength) {
          this.isValid = val.length <= this.maxLength
        }
      } else if (this.options.required) {
        this.isValid = false
        this.isDirty = true
      } else {
        this.isValid = true
      }
    },
    addSearchValue (e) {
      // check if enter key is pressed, then add value
      let key = e.which || e.keyCode
      if (key === 13 && !this.currentResults) {
        this.choices.setValue([this.choices.currentValue])
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/inputs/TextSelectInput.vue